/** @file guideRegionsOf: the coloured regions of a guide sheet, one distinct flat colour per node part. */
import { primaryPartsOf } from './primaryPartsOf';
import type { GuideRegion, RestPlacement } from './sheetTypes';

/** HSV (h degrees, s and v 0..1) to 0..255 RGB. */
function hsv(h: number, s: number, v: number): [number, number, number] {
  const f = (n: number): number => {
    const k = (n + h / 60) % 6;
    return Math.round(255 * (v - v * s * Math.max(0, Math.min(k, 4 - k, 1))));
  };
  return [f(5), f(3), f(1)];
}

/** Two hex digits. */
const hex2 = (n: number): string => n.toString(16).padStart(2, '0');

/**
 * `primaryPartsOf(placement.parts)` far to near, each with colour i of a golden-angle hue walk (saturated, bright,
 * never near black or white, so outlines, joint dots and a painted figure stay apart from it).
 */
export function guideRegionsOf(placement: RestPlacement): GuideRegion[] {
  return primaryPartsOf(placement.parts).map((part, i) => {
    const [r, g, b] = hsv((i * 137.508 + 10) % 360, 0.7, i % 2 === 0 ? 0.95 : 0.8);
    return { part, color: [r, g, b, 255], hex: `#${hex2(r)}${hex2(g)}${hex2(b)}` };
  });
}
